import { Link } from "react-router-dom";
import { clinicInfo } from "@/mocks/site";

export default function MobileCtaBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-background-200 bg-background-50/95 backdrop-blur md:hidden">
      <div className="grid grid-cols-2 gap-2 px-3 py-2">
        <a
          href={clinicInfo.phoneHref}
          className="flex items-center justify-center gap-2 rounded-md border border-primary-200 py-2.5 font-label text-sm font-semibold text-primary-700"
        >
          <i className="ri-phone-fill" aria-hidden="true"></i>
          Call Now
        </a>
        <Link
          to="/appointment"
          className="flex items-center justify-center gap-2 rounded-md bg-primary-500 py-2.5 font-label text-sm font-semibold text-background-50"
        >
          <i className="ri-calendar-check-line" aria-hidden="true"></i>
          Book Appointment
        </Link>
      </div>
    </div>
  );
}